"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../constants/strings");
const approvalQuery_1 = require("../../../../../queries/approvals/approvalQuery");
const Root_1 = require("../../../../../router/Root");
const zustandStore_1 = require("../../../../../zustandStore");
const approvalHelpers_1 = require("../../approvalHelpers");
const createCardButton_1 = require("./createCardButton");
const lexico = new lexico_1.default();
const DeclineButton = ({ approvalItem }) => {
    const params = (0, react_router_1.useParams)();
    const { setDialog } = (0, zustandStore_1.useZustand)();
    const { state, outcome } = approvalItem || {};
    const viewAllApprovals = (0, zustandStore_1.useZustand)(state => state.activity.viewAllApprovals);
    const isActivityPage = location.pathname.startsWith('/approvals') || location.pathname.startsWith('/activity');
    const isActionable = (isActivityPage && !viewAllApprovals) || (state === 'ASSIGNED' && !(0, approvalHelpers_1.isProcessing)(approvalItem));
    const declineApprovalQuery = (0, approvalQuery_1.useDeclinePendingApprovalMutationQuery)();
    const handleDeclineRequest = () => {
        declineApprovalQuery.mutate({ subjectId: approvalItem?.subjectId, taskId: approvalItem?.id }, {
            onSettled: () => {
                if (params?.['approvalId']) {
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: ['approval', params?.['approvalId']],
                    });
                }
            },
        });
    };
    const activeHeaderTab = (0, zustandStore_1.useZustand)(state => state.header.activeHeaderTab);
    const handleDeclineModal = () => {
        if (!approvalItem?.subjectId || !approvalItem?.id) {
            return;
        }
        setDialog({
            message: lexico.trc('Warning', 'The request will be declined and the requester will be notified. Would you like to proceed?'),
            type: strings_1.notificationStrings.WARNING,
            open: true,
            actionText: 'YES',
            showCancel: true,
            onAccept: handleDeclineRequest,
        });
    };
    const showBtnCondition = outcome === undefined || !createCardButton_1.hideBtnOutcomes.includes(outcome) ? isActionable && !approvalItem.isApproved : false;
    const isOnActivityPage = isActivityPage && !params['approvalId'];
    const showBtn = isOnActivityPage
        ? showBtnCondition && activeHeaderTab === 'pending'
        : showBtnCondition && activeHeaderTab
            ? activeHeaderTab === 'pending'
            : showBtnCondition;
    return (showBtn && ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, color: "secondary", onClick: handleDeclineModal, children: lexico.trc('Button', 'Decline') })));
};
exports.default = DeclineButton;
